
import { Component, Vue, Emit } from 'vue-property-decorator';
import { BaseText, Modal, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { Steps } from '../PortfolioSuggestedModal/PortfolioSuggestedModal.vue';
import { SuggestionModule } from '@/modules/home/store/suggestions';
import { IGetInstrumentProductValidationErrorTypes } from '@/modules/wealth/services/investment';
import * as trackInvestmentEvents from './track-investment-events';
import * as trackRedeemEvents from './track-redeem-events';
import { SuggestionType } from '@/modules/investments/types/suggestion';

@Component({
  components: { BaseText, Modal, ButtonPrimary }
})
export default class SuggestedValidationError extends Vue {
  @Emit('on-close')
  closeModal() {}

  get suggestionType() {
    return SuggestionModule.suggestionType;
  }

  get errorTitle() {
    return SuggestionModule.validationError.title;
  }

  get errorDescription() {
    return SuggestionModule.validationError.message;
  }

  created() {
    if (this.suggestionType === SuggestionType.Investment) {
      trackInvestmentEvents.viewSuggestedValidationErrorAmplitude(
        this.messageTracking
      );
    } else if (this.suggestionType === SuggestionType.Redeem) {
      trackRedeemEvents.trackViewinvalidRedeemSuggestion();
    }
  }

  @Emit('modal-navigate')
  handleBack() {
    if (this.suggestionType === SuggestionType.Redeem) {
      trackRedeemEvents.trackClickGoBackRedeemSuggestion();
    }

    return Steps.List;
  }

  private get messageTracking() {
    if (
      SuggestionModule.validationError.type ===
      IGetInstrumentProductValidationErrorTypes.InvestmentInvalid
    ) {
      return 'Sugestão inválida';
    }

    return 'Sugestão indisponível';
  }
}
